import { useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { NAV, CONTACT, MEDIA } from "@/lib/data";

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const showFab = location.pathname !== "/contactos";

  return (
    <>
      <header
        data-testid="site-header"
        className="fixed top-0 inset-x-0 z-40 bg-[#0d4c7d]/95 backdrop-blur-md border-b-2 border-[#1FA8E0] text-white"
      >
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-[88px] md:h-[96px] flex items-center justify-between">
          <Link to="/" data-testid="header-logo-link" className="flex items-center py-2">
            <img
              src={MEDIA.logo}
              alt="CETIBER — Sistemas de Fixação"
              className="h-16 md:h-20 w-auto object-contain"
            />
          </Link>

          <nav className="hidden lg:flex items-center gap-9">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                data-testid={`nav-${item.to.replace("/", "") || "home"}`}
                className={({ isActive }) =>
                  `ulink font-display uppercase tracking-wider text-sm font-semibold ${
                    isActive ? "text-white active" : "text-white/85 hover:text-white"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-4">
            <a
              href={CONTACT.telefoneHref}
              data-testid="header-phone"
              className="font-mono-cet text-xs tracking-widest text-white/80 hover:text-white"
            >
              {CONTACT.telefone}
            </a>
            <Link
              to="/contactos"
              data-testid="header-cta-contact"
              className="btn-cet btn-primary"
            >
              <Phone size={16} /> Contactar
            </Link>
          </div>

          <button
            data-testid="header-menu-toggle"
            className="lg:hidden p-2"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {open && (
          <div data-testid="mobile-menu" className="lg:hidden border-t border-white/10 bg-[#0a3a60]">
            <div className="flex flex-col p-5 gap-2">
              {NAV.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/"}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-${item.to.replace("/", "") || "home"}`}
                  className={({ isActive }) =>
                    `font-display uppercase tracking-wider text-base py-3 border-b border-white/10 ${
                      isActive ? "text-[#1FA8E0]" : "text-white"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
              <Link
                to="/contactos"
                onClick={() => setOpen(false)}
                data-testid="mobile-cta-contact"
                className="btn-cet btn-primary mt-3 justify-center"
              >
                <Phone size={16} /> Contactar
              </Link>
            </div>
          </div>
        )}
      </header>

      {showFab && (
        <Link
          to="/contactos"
          data-testid="floating-contact-btn"
          className="fab-contact hidden md:inline-flex"
        >
          <Phone size={16} /> Contactar
        </Link>
      )}
    </>
  );
}
